import { render, staticRenderFns } from "./businessCopyWindow.vue?vue&type=template&id=3e87b63a&"
import script from "./businessCopyWindow.vue?vue&type=script&lang=js&"
export * from "./businessCopyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e87b63a')) {
      api.createRecord('3e87b63a', component.options)
    } else {
      api.reload('3e87b63a', component.options)
    }
    module.hot.accept("./businessCopyWindow.vue?vue&type=template&id=3e87b63a&", function () {
      api.rerender('3e87b63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/businessCopyWindow.vue"
export default component.exports